var map = {
	"./images/asequals.png": 145,
	"./images/create.png": 146,
	"./images/ft.png": 147,
	"./images/share-campaign.png": 148,
	"./images/share.png": 149,
	"./images/showreel.gif": 150,
	"./images/spacer.png": 151,
	"./pdf/Freelance Web Developer for Editorial Storytelling & Microsites.pdf": 167,
	"./videos/Denis-Bouquet-Portfolio-60s.mp4": 152,
	"./videos/showreel-60.mp4": 153,
	"./videos/showreel.mp4": 154
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 166;


//////////////////
// WEBPACK FOOTER
// ./src/media ^\.\/.*\.*
// module id = 166
// module chunks = 0